import {Static, StaticDecode, TSchema} from "typebox";
import {q, useQueryData} from "../state";
import {clearLocalState, useLocalState} from "./localState";
import {Dispatch, SetStateAction} from "react";
import {escapeRegExp} from "lodash-es";

type TJson<T extends TSchema> = Static<T> extends unknown ? T : never;

export function useAccountLocalState<S extends TSchema>(
  storageKey: string,
  schema: TJson<S>,
  defaultValue: StaticDecode<S>,
): [StaticDecode<S>, Dispatch<SetStateAction<StaticDecode<S>>>] {
  const whoAmI = useQueryData(q.whoAmIOnAccount());
  const accountId = whoAmI.account?.account_id;
  const k = `p4daccountid-${accountId}:${storageKey}`;
  return useLocalState(k, schema, defaultValue);
}

export function clearAllAccountLocalStates(storageKey: string) {
  const matcher = new RegExp(`^p4daccountid-[0-9a-zA-Z-]+:${escapeRegExp(storageKey)}$`);
  clearLocalState(matcher);
}
